import type { I18nFn } from '#/i18n/types/I18nFn';
import type { EducationLevel } from '#/utils/constants/general/educationLevels';
import { EDUCATION_LEVELS } from '#/utils/constants/general/educationLevels';
import type { ProfessionalLevel } from '#/utils/constants/general/professionalLevels';
import { PROFESSIONAL_LEVELS } from '#/utils/constants/general/professionalLevels';

export function getProfessionalLevelName(
  i18n: I18nFn,
  levelId: ProfessionalLevel,
) {
  return PROFESSIONAL_LEVELS(i18n)[levelId];
}

export function getEducationLevelName(i18n: I18nFn, levelId: EducationLevel) {
  return EDUCATION_LEVELS(i18n)[levelId];
}
